function renderDisplayDate(d: Date, slash?: boolean, showYear?: boolean) {

  if (!d) return '';


  if (typeof (d.getFullYear) !== 'function') {
    d = new Date(d);
  }


  const today = new Date();

  if (slash) {
    if (d.getFullYear() === today.getFullYear() && showYear !== true) {
      return `${d.getMonth() + 1}/${d.getDate()}`;
    }
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
  }


  if (d.getFullYear() === today.getFullYear() && d.getMonth() ===
    today.getMonth() && d.getDate() === today.getDate()) {

    if (today.getHours() === d.getHours())
      return `${today.getMinutes() - d.getMinutes()} 分鐘前`;

    return `${today.getHours() - d.getHours()} 小時前`;

  }

  const diffTime = Math.abs(today.getTime() - d.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 1)
    return '昨天';

  if (diffDays <= 7)
    return diffDays + ' 天前';

  if (d.getFullYear() === today.getFullYear()) {
    return `${d.getMonth() + 1} 月 ${d.getDate()} 日`;
  }

  return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月 ${d.getDate()} 日`;
}

export default renderDisplayDate;
